import { SVGProps } from 'react';

function ToggleOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="2" y="3" width="36" height="18" rx="9" fill="#BABBC0" />
      <g filter="url(#filter0_d_5506_301)">
        <circle cx="12" cy="12" r="6" fill="white" />
      </g>
      <defs>
        <filter id="filter0_d_5506_301" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.172549 0 0 0 0 0.278431 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5506_301" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5506_301" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default ToggleOffIcon;
